// Shared one-liners about fucking up and the very specific dumb crimes
// people commit, used in two places:
//   1. The first-touch MusicInterstitial that gates audio unlock
//   2. The slideshow's "every-3-slides" pause card
//
// Voice: dry, deadpan, NJ-municipal-court realism mixed with Adams-style
// absurd specificity. Half pattern-observations, half "the rotisserie
// chicken" energy. Kept short — 1-2 lines so the eye lands fast.

export interface Quote {
  text: string;
  attrib?: string;
}

export const QUOTES: Quote[] = [
  // — Specific bad-decision incidents (the rotisserie-chicken energy) —
  { text: "He had a plan. The plan involved a rotisserie chicken and a hoodie." },
  { text: "It seemed reasonable at 2:47 AM. It seemed less reasonable at 2:48." },
  { text: "The breathalyzer cannot be reasoned with." },
  { text: "Stealing the rotisserie chicken was the easy part. Walking out with it was the tell." },
  { text: "Driving backwards down the off-ramp does, in fact, count." },
  { text: "You cannot pay a fine with a coffee shop punch card. Even a fully-stamped one." },
  { text: "He told the officer he was a paralegal. He had not, technically, ever been a paralegal." },
  { text: "There is no DUI defense that begins with 'But the deer was driving.'" },
  { text: "An open container in the cup-holder is, legally, a confession." },
  { text: "If your defense begins with 'technically,' the verdict has already been written." },
  { text: "Some plans collapse the moment you say them out loud." },
  { text: "When the officer says 'do you know why I pulled you over,' do not answer with a list." },
  { text: "Parking in front of the precinct because nobody would suspect: a strategy with a name and a courtroom." },
  { text: "A field sobriety test is not a Yelp review. The cones do not care." },
  { text: "Tell them you're a paralegal. Just say the word 'paralegal' a lot. This has never worked." },
  { text: "Hold the wheel with your knee — I need both hands for the firework." },

  // — Pattern observations (the municipal-court realism) —
  { text: "If the cop is laughing while writing the ticket, you have made history." },
  { text: "There is a Wawa for every bad decision. Sometimes the same Wawa twice." },
  { text: "The phrase 'I'll just pay it later' has cost more careers than the actual ticket." },
  { text: "Every parking ticket is a love note from the municipality. Some of us write back." },
  { text: "Ten years ago you swore you'd never come back here. Welcome back." },
  { text: "Every fail-to-yield is a small miracle of survival." },
  { text: "The clerk has seen worse. The clerk has also seen this exact thing." },
  { text: "Some men contain multitudes. Some contain six fail-to-yields and a public urination." },
  { text: "Whatever you were about to do, the bench has already heard a worse version of it." },
  { text: "If you're explaining yourself to the officer, you've already lost. Twice." },
  { text: "Officer Reyes has met every version of you. He is unimpressed." },
  { text: "The Garden State Parkway has seen everything. So has Tasha." },
  { text: "You cannot outrun a county. You can only owe it more." },
  { text: "Fines double when ignored. Patience does not." },
];

export function pickRandomQuote(exclude?: string): Quote {
  if (QUOTES.length === 0) throw new Error("no quotes defined");
  if (QUOTES.length === 1) return QUOTES[0]!;
  let q: Quote;
  let attempts = 0;
  do {
    q = QUOTES[Math.floor(Math.random() * QUOTES.length)]!;
    attempts++;
  } while (q.text === exclude && attempts < 5);
  return q;
}
